/**
 * 找资源模块子路由
 * 路径均为相对路径，根路由会以 /resource 为前缀挂载
 */

export const resourceRoutes = [
  {
    path: 'main',
    name: 'ResourceMain',
    component: () => import('@/modules/resource/views/main/index.vue'),
    meta: { title: '搜索资源' }
  },
  {
    path: 'cart',
    name: 'ResourceCart',
    component: () => import('@/modules/resource/views/cart/index.vue'),
    meta: { title: '采购车' }
  },
  {
    path: 'order',
    name: 'ResourceOrder',
    component: () => import('@/modules/resource/views/order/index.vue'),
    meta: { title: '订单' }
  }
]

export default resourceRoutes